import { forIn, set } from 'lodash';
import * as actions from '../actions';
import produce from 'immer';
export var componentReducer = produce(function (draft, action) {
  var type = action.type,
      componentId = action.componentId,
      payload = action.payload;

  if (componentId === undefined) {
    return;
  }

  if (draft[componentId] === undefined) {
    draft[componentId] = {};
  }

  var componentState = draft[componentId];

  switch (type) {
    case actions.COMPONENT_UNMOUNT:
      delete draft[componentId];
      break;

    case actions.COMPONENT_FORM_INIT:
      Object.assign(componentState, payload);
      componentState.status = {};
      break;

    case actions.COMPONENT_FORM_CHANGE:
      if (!componentState.fields) {
        componentState.fields = {};
      }

      var fields_1 = componentState.fields;
      forIn(payload, function (value, key) {
        set(fields_1, key, value);
      });
      break;

    case actions.COMPONENT_FORM_STATUS_CHANGE:
      Object.assign(componentState.status, payload);
      break;

    case actions.COMPONENT_SUBMIT:
      componentState.submitType = payload;
      break;

    case actions.COMPONENT_SUBMIT_FINISH:
      componentState.submitType = null;
      break;

    case actions.COMPONENT_TABLE_ROW_SELECTION_CHANGE:
      componentState.selectedRowKeys = payload;
      break;

    case actions.COMPONENT_TABLE_MODIFY_START:
      componentState.fields = payload;
      break;

    case actions.COMPONENT_TABLE_MODIFY_CHANGE:
      Object.assign(componentState.fields, payload);
      break;

    case actions.COMPONENT_TABLE_MODIFY_FINISH:
      componentState.fields = null;
      break;

    case actions.COMPONENT_TABLE_SORT_CHANGE:
      componentState.sort = payload;
      break;

    default:
  }
}, {});